// extracted by mini-css-extract-plugin
export default {"widget-panel":"widget-panel_widget-panel__+Ds2P","button-close":"widget-panel_button-close__LYUsT"};